(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const templates=[...root.querySelectorAll('template[data-pool]')];
    const signature=templates.map(t=>t.dataset.pool+':'+t.dataset.productId).join(',');
    const key='figini-selection:'+root.dataset.figiniSelection;
    let saved;
    try { saved=JSON.parse(sessionStorage.getItem(key)); } catch {}
    let ids=saved?.signature===signature ? saved.ids : null;
    if(!Array.isArray(ids)) {
      ids=[];
      for(const gender of ['1','2']) {
        const pool=templates.filter(t=>t.dataset.pool===gender&&!ids.includes(t.dataset.productId));
        for(let i=pool.length-1;i>0;i--) {const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
        for(const t of pool) {if(!ids.includes(t.dataset.productId)) ids.push(t.dataset.productId);if(ids.filter(id=>pool.some(t=>t.dataset.productId===id)).length>=4) break;}
      }
      try {sessionStorage.setItem(key,JSON.stringify({signature,ids}));} catch {}
    }
    const fragment=document.createDocumentFragment();
    for(const id of ids) {const t=templates.find(t=>t.dataset.productId===id);if(t) fragment.append(t.content.cloneNode(true));}
    if(fragment.childNodes.length) root.querySelector('[data-selected]').replaceChildren(fragment);
  }
  document.querySelectorAll('[data-figini-selection]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-figini-selection]').forEach(init));
})();
